<!-- superadmin-layout.component.html -->
<div class="sa-layout">

  <!-- ══════════════════════════════════════
       SIDEBAR
  ══════════════════════════════════════ -->
  <aside class="sa-sidebar" [class.is-collapsed]="collapsed">

    <!-- Brand -->
    <div class="sa-sb-brand">
      <div class="sa-sb-logo">
        <img src="assets/images/logo.png" alt="FieldOps"
             onerror="this.style.display='none';this.nextElementSibling.style.display='flex'"/>
        <span style="display:none">FO</span>
      </div>
      <div class="sa-sb-brand-text">
        <span class="sa-sb-brand-name">FieldOps</span>
        <span class="sa-sb-brand-role">Super Admin</span>
      </div>
      <button class="sa-sb-toggle" (click)="collapsed = !collapsed">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M10 12L6 8L10 4" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>

    <!-- Nav -->
    <nav class="sa-sb-nav">

      <div class="sa-sb-section">Platform</div>

      <a routerLink="/superadmin/dashboard"
         routerLinkActive="sa-active"
         class="sa-sb-link">
        <span class="sa-sb-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <rect x="3" y="3" width="7" height="7" rx="1.5" stroke="currentColor" stroke-width="1.8"/>
            <rect x="14" y="3" width="7" height="7" rx="1.5" stroke="currentColor" stroke-width="1.8"/>
            <rect x="3" y="14" width="7" height="7" rx="1.5" stroke="currentColor" stroke-width="1.8"/>
            <rect x="14" y="14" width="7" height="7" rx="1.5" stroke="currentColor" stroke-width="1.8"/>
          </svg>
        </span>
        <span class="sa-sb-label">Dashboard</span>
      </a>

      <a routerLink="/superadmin/companies"
         routerLinkActive="sa-active"
         class="sa-sb-link">
        <span class="sa-sb-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path d="M3 21V7L12 3L21 7V21" stroke="currentColor" stroke-width="1.8"
                  stroke-linecap="round" stroke-linejoin="round"/>
            <rect x="9" y="14" width="6" height="7" rx="1" stroke="currentColor" stroke-width="1.8"/>
            <rect x="5" y="10" width="3" height="3" rx=".5" stroke="currentColor" stroke-width="1.5"/>
            <rect x="16" y="10" width="3" height="3" rx=".5" stroke="currentColor" stroke-width="1.5"/>
          </svg>
        </span>
        <span class="sa-sb-label">Companies</span>
        <span class="sa-sb-badge" *ngIf="companyCount > 0">{{ companyCount }}</span>
      </a>

      <a routerLink="/superadmin/workers"
         routerLinkActive="sa-active"
         class="sa-sb-link">
        <span class="sa-sb-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="1.8"/>
            <path d="M2 20C2 17 5 14 9 14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
            <path d="M16 14C19.3 14 22 16.7 22 20" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
            <circle cx="17" cy="10" r="3" stroke="currentColor" stroke-width="1.8"/>
          </svg>
        </span>
        <span class="sa-sb-label">All Workers</span>
      </a>

      <a routerLink="/superadmin/jobs"
         routerLinkActive="sa-active"
         class="sa-sb-link">
        <span class="sa-sb-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <rect x="2" y="7" width="20" height="14" rx="2" stroke="currentColor" stroke-width="1.8"/>
            <path d="M16 7V5C16 3.9 15.1 3 14 3H10C8.9 3 8 3.9 8 5V7"
                  stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
          </svg>
        </span>
        <span class="sa-sb-label">All Jobs</span>
      </a>

    </nav>

    <!-- Footer -->
    <div class="sa-sb-footer">
      <div class="sa-sb-user">
        <div class="sa-sb-avatar">{{ userInitial }}</div>
        <div class="sa-sb-user-info">
          <span class="sa-sb-user-name">{{ userName }}</span>
          <span class="sa-sb-user-role">Super Admin</span>
        </div>
      </div>
      <button class="sa-sb-logout" (click)="logout()" title="Logout">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path d="M9 21H5C4.5 21 4 20.8 3.6 20.4C3.2 20 3 19.5 3 19V5C3 4.5 3.2 4 3.6 3.6C4 3.2 4.5 3 5 3H9"
                stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
          <polyline points="16 17 21 12 16 7" stroke="currentColor" stroke-width="1.8"
                    stroke-linecap="round" stroke-linejoin="round"/>
          <line x1="21" y1="12" x2="9" y2="12" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        </svg>
      </button>
    </div>

  </aside>

  <!-- ══════════════════════════════════════
       MAIN AREA
  ══════════════════════════════════════ -->
  <div class="sa-main">

    <!-- Topbar -->
    <header class="sa-topbar">
      <div class="sa-topbar-left">
        <button class="sa-topbar-hamburger" (click)="collapsed = !collapsed">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <line x1="3" y1="6"  x2="21" y2="6"  stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <line x1="3" y1="12" x2="21" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <line x1="3" y1="18" x2="16" y2="18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>
        <div class="sa-topbar-badge">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
            <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
                  fill="currentColor"/>
          </svg>
          Super Admin Console
        </div>
      </div>

      <div class="sa-topbar-right">
        <span class="sa-topbar-env">Platform View</span>
        <button class="sa-topbar-logout-btn" (click)="logout()">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
            <path d="M9 21H5C4.5 21 4 20.8 3.6 20.4C3.2 20 3 19.5 3 19V5C3 4.5 3.2 4 3.6 3.6C4 3.2 4.5 3 5 3H9"
                  stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
            <polyline points="16 17 21 12 16 7" stroke="currentColor" stroke-width="1.8"
                      stroke-linecap="round" stroke-linejoin="round"/>
            <line x1="21" y1="12" x2="9" y2="12" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
          </svg>
          Logout
        </button>
      </div>
    </header>

    <!-- Page content -->
    <main class="sa-content">
      <router-outlet></router-outlet>
    </main>

  </div>
</div>